import { asStates } from './asStates'
import { caStates } from './caStates'
import { countries } from './countries'
import {
  ctrIdentificationTypes,
  ctrIdentificationTypesLabels,
  ctrIdentificationTypesValues
} from './ctrIdentificationTypes'
import { ctrPersonTypes, ctrPersonTypesValues } from './ctrPersonTypes'
import { ctrTINTypes } from './ctrTINTypes'
import { fmStates } from './fmStates'
import { gender } from './gender'
import { guStates } from './guStates'
import { mhStates } from './mhStates'
import { mpStates } from './mpStates'
import { mxStates } from './mxStates'
import { prStates } from './prStates'
import { pwStates } from './pwStates'
import { usAndTerritories } from './usAndTerritories'
import { usStates } from './usStates'
import { viStates } from './viStates'

export * from './bsaCTRStatuses'
export * from './bsaBatchStatuses'
export * from './adverseMediaEntityTypes'
export * from './adverseMediaRiskLevels'
export * from './filingTypes'
export * from './financialInstitutionRoles'
export * from './states'
export * from './typesOfFinancialInstitution'
export * from './primaryFederalRegulators'
export * from './countries'
export * from './filingInstitutionIDTypes'
export * from './ctrTINTypes'
export * from './sarSubjectIdentificationTypes'
export * from './sarSubjectRoleInSuspiciousActivityTypes'
export * from './phoneTypeTypes'
export * from './gender'
export * from './usAndTerritories'
export * from './mhStates'
export * from './usStates'
export * from './caStates'
export * from './guStates'
export * from './fmStates'
export * from './mxStates'

export const dictionary = {
  asStates,
  caStates,
  countries,
  ctrIdentificationTypes,
  ctrIdentificationTypesLabels,
  ctrIdentificationTypesValues,
  ctrPersonTypes,
  ctrPersonTypesValues,
  ctrTINTypes,
  fmStates,
  gender,
  guStates,
  mhStates,
  usStates,
  mpStates,
  mxStates,
  prStates,
  pwStates,
  viStates,
  usAndTerritories
}
